module.exports = __webpack_public_path__ + "static/media/can-mother-be-wrong.5de1abce.txt";